// Grupo de lista
(function () {
  // var gruposSortable = [];

  $('.pag-blog-categorias .sortable').each(function (index) {
    const sortableGroup = new Sortable($(this)[0], {
      group: `grupo-${index}`,
      animation: 150,
      ghostClasse: 'sortable-ghost',
      fallbackOnBody: true,
      onStart: function () {
        $('body').addClass('grabbing');
      },
      onEnd: function () {
        $('body').removeClass('grabbing');
      },
      onUpdate: function (ev) {
        const instance = this;
        const order = instance.toArray();
        const idItem = ev.item.dataset['row'];
        const position = ev.newIndex + 1;
        const dados_tabela = {
          id: idItem,
          position,
        };
        // console.log(dados_tabela);
        atualizaPosicao(dados_tabela);
      },
      store: {
        /**
         * Get the order of elements. Called once during initialization.
         * @param   {Sortable}  sortable
         * @returns {Array}
         */
        // get: function (sortable) {
        //   var order = localStorage.getItem(sortable.options.group.name);
        //   return order ? order.split('|') : [];
        // },
        /**
         * Save the order of elements. Called onEnd (when the item is dropped).
         * @param {Sortable}  sortable
         */
        // set: function (sortable) {
        //   var order = sortable.toArray();
        //   localStorage.setItem(sortable.options.group.name, order.join('|'));
        // },
      },
    });
    // gruposSortable.push(sortableGroup);
  });

  /**
   * Atualiza posição no banco de dados
   *
   */
  function atualizaPosicao(dados_tabela) {
    const url = $('[data-url-base]').data('url-base');
    const token = $('[data-token]').data('token');
    let dados = {
      token,
      acao: 'atualiza_posicao',
    };
    dados = { ...dados, ...dados_tabela };

    $.post(
      url,
      dados,
      function (result) {
        // Sucesso
        if (result.status == 'success') {
        }
        // Erro
        else {
        }
      },
      'json',
    );
  }

  $(document).on('remove_unico remove', () => {
    setTimeout(() => {
      window.location.reload();
    }, 1200);
  });
})();

// Escolhendo seo para categoria
(function () {
  'use strict';

  const $seoCategoria = $('#seo-blog-categoria');
  if ($seoCategoria[0]) {
    // Variáveis
    const $campoDominio = $('#mplp_domain');
    const $campoTitle = $('#titulo');
    const $seoTitle = $('#seo_titulo');
    const $campoPag = $('#cat_pag');
    const $pagePreview = $('.category-url-preview-pag');

    // Ao cadastrar uma categoria e editar o título
    if ($seoTitle.length > 0 && $('input[name="acao"]').val() == 'insert') {
      $campoTitle.on('change', function () {
        $seoTitle.val($(this).val()).trigger('change');
      });
    }

    $seoTitle.on('change input', function (ev) {
      let slug = slugify($seoTitle.val());
      if ($campoPag.val().length == 0 || slug.substr(0, slug.length - 1) == $campoPag.val()) {
        $campoPag.val(slugify($(this).val())).trigger('change');
      }
    });

    // Ao alterar a url da página
    $campoPag.on('input change', handlePagLp);

    // Ao alterar a url da página
    handlePagLp();
    function handlePagLp() {
      let pag = $campoPag.val();
      if (pag == '' && $pagePreview.data('placeholder')) {
        $pagePreview.text($pagePreview.data('placeholder'));
      } else {
        $pagePreview.text(pag);
      }
    }
  }
})();
